import { ReactNode, useEffect } from "react";
import { ModalOverLay, Wrapper } from "./styled";
import * as React from "react";
import { GlobalModalStyle } from "../../../utils/commonStyledComponents/commonStyled";
import CloseButton from "../TopRightCornerCloseButton/CloseButton";
import { CSSProperties } from "styled-components";

interface CustomModalProps {
  onClose?: () => void;
  children: ReactNode;
  footer?: ReactNode;
  dataTestId?: string;
  overlayStyles?: CSSProperties;
  wrapperStyles?: CSSProperties;
  navigationDirection?: "left" | "right" | null;
  animate?: boolean;
}

const CustomModal: React.FC<CustomModalProps> = ({
  onClose,
  children,
  footer,
  dataTestId,
  overlayStyles,
  wrapperStyles,
  navigationDirection = null,
  animate = false,
}) => {
  useEffect(() => {
    // Prevent body scroll when modal is mounted
    const scrollY = window.scrollY;
    document.body.style.overflow = "hidden";
    document.body.style.position = "fixed";
    document.body.style.width = "100%";
    document.body.style.top = `-${scrollY}px`;

    return () => {
      // Restore body scroll when modal is unmounted
      document.body.style.overflow = "";
      document.body.style.position = "";
      document.body.style.width = "";
      document.body.style.top = "";
      window.scrollTo(0, scrollY);
    };
  }, []);

  return (
    <>
      <GlobalModalStyle />
      <ModalOverLay
        // onClick={onClose}
        data-testid={`${dataTestId}`}
        customStyles={overlayStyles}
      >
        <Wrapper
          onClick={(e) => e.stopPropagation()}
          customStyles={wrapperStyles}
          navigationDirection={navigationDirection}
          animate={animate}
        >
          <CloseButton
            onClose={() => {
              onClose && onClose();
            }}
            sx={{
              zIndex: 991,
            }}
          ></CloseButton>
          {children}
        </Wrapper>
        {footer}
      </ModalOverLay>
    </>
  );
};

export default CustomModal;
